import React, {useRef, useEffect} from 'react';
import {RssiScaleBarLayer} from '../../../../components/connectivity-guru/wifi-analyzer-scan/components/layers/RssiScaleBarLayer';

export const RssiScaleBarOverlay = (): JSX.Element => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const container = containerRef.current;

        if (!canvas || !container) {
            return;
        }

        const resizeObserver = new ResizeObserver(() => draw(canvas, container));

        resizeObserver.observe(container);
        draw(canvas, container);

        return () => resizeObserver.disconnect();
    }, []);

    return (
        <div ref={containerRef} className='rssi-scale-bar-overlay'>
            <canvas ref={canvasRef} />
        </div>
    );
};

function draw(canvas: HTMLCanvasElement, container: HTMLDivElement): void {
    const width = container.clientWidth;
    const layer = new RssiScaleBarLayer(undefined, {width});
    const height = RssiScaleBarLayer.getRecommendedHeight();
    const dpr = window.devicePixelRatio || 1;

    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.height = `${height}px`;

    const ctx = canvas.getContext('2d');

    if (!ctx) {
        return;
    }

    ctx.scale(dpr, dpr);
    layer.render(ctx, width, height, {bottomPadding: 0});
}
